<template>
    <div class="embryo-development-card">
        <embryo-development-form
            :well="well"
            :show-eq-score="showEqScore"
            :class="well.status"
            @eqScoreToggled="$emit('eqScoreToggled')"
        />

        <div v-if="showImages" class="images">
            <div v-for="(imageUrl, key) in imagesByDay" :key="key" class="event-block">
                <div class="day-count">
                    <span>{{ $translate('day') }} {{ key }}</span>
                </div>

                <day-image :image-url="imageUrl || ''" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { WELL_STATUS } from '../../../../business/factory/DataModel'
import Utils from '../../../../business/utils/Utils'
import EmbryoDevelopmentForm from './EmbryoDevelopmentForm'
import DayImage from '../DayImage'

export default {
    name: 'EmbryoDevelopmentCard',
    components: { EmbryoDevelopmentForm, DayImage },
    props: {
        well: {
            type: Object,
            required: true
        },
        showEqScore: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getPnImageUrl: 'timelapse/getPnImageUrl'
        }),
        showImages() {
            return this.well.status !== WELL_STATUS.DISCARDED
        },
        pnImageUrl() {
            return this.getPnImageUrl(this.well)
        },
        imagesByDay() {
            const maxHourByDay = {
                2: 45,
                3: 69,
                4: 94,
                5: 118,
                6: 138,
                7: 162
            }

            const imagesByDay = {
                1: this.pnImageUrl
            }

            // for avoiding duplicated images
            const frameIds = new Set()
            frameIds.add('PN')

            Object.keys(maxHourByDay).forEach(key => {
                const maxHour = maxHourByDay[key]

                const latestRunIndex = this.well.runs.findLastIndex(
                    run => !!run && run.time < maxHour
                )

                if (latestRunIndex === -1) {
                    imagesByDay[key] = null
                    return
                }

                const frameId = this.well.videoFramesTime[latestRunIndex]
                const alreadyShown = frameIds.has(frameId)

                if (alreadyShown) {
                    imagesByDay[key] = null
                    return
                }

                imagesByDay[key] = Utils.getImageUrlFromTime(this.well, frameId)
                frameIds.add(frameId)
            })

            return imagesByDay
        }
    }
}
</script>

<style lang="scss" scoped>
$active: $light-3;
$passive: $light;

.embryo-development-card {
    display: grid;
    grid-template-rows: 1fr min-content;

    .embryo-development-form {
        @media screen {
            &:not(.DISCARDED) {
                margin-bottom: 10px;
            }
        }
    }

    .images {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));

        @media screen {
            border: solid 1px $active;
            border-radius: 4px;
        }
        @media print {
            border: solid 1px $report-color;
        }

        .event-block {
            display: grid;
            grid-template-rows: 30px 120px;

            .day-count {
                padding: 5px;
                text-align: center;

                @media screen {
                    border-bottom: solid 1px $active;
                }
                @media print {
                    border-bottom: solid 1px $report-color;
                }
            }

            &:not(:first-child) {
                .day-count,
                .day-image {
                    @media screen {
                        border-left: solid 1px $active;
                    }
                    @media print {
                        border-left: solid 1px $report-color;
                    }
                }
            }
        }
    }
}
</style>
